import React from 'react'
import { Info } from 'lucide-react'

// What a channel card says instead of a funnel of zeros: where the
// integration stands and what happens next.
export default function EmptyChannel({ children }) {
  return (
    <div role="note" style={{
      display: 'flex', gap: 10, alignItems: 'flex-start', padding: '14px 16px',
      borderRadius: 12, background: 'var(--bg-raised)', fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5,
    }}>
      <Info size={16} aria-hidden="true" style={{ flexShrink: 0, marginTop: 2, color: 'var(--text-muted)' }} />
      <span>{children}</span>
    </div>
  )
}
